import { IconProps } from '@models/icons';

function InfoIcon(props:IconProps) {
    return (
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...props} >
            <path
                d="M12.5 5.47461C16.1037 5.47461 19.0254 8.39634 19.0254 12C19.0254 15.6037 16.1037 18.5254 12.5 18.5254C8.89634 18.5254 5.97461 15.6037 5.97461 12C5.97461 8.39634 8.89634 5.47461 12.5 5.47461Z"
                stroke="#A5AAAF" strokeWidth="1.45"/>
            <path
                d="M12.4561 13.7193C12.1674 13.7193 11.9224 13.4967 11.9259 13.2081C11.9527 11.0143 13.545 11.3615 13.545 9.88892C13.545 8.89868 13.0335 8.67016 12.5112 8.67016C11.9624 8.67016 11.5772 8.90819 11.4172 9.60565C11.3535 9.88337 11.1259 10.1066 10.8409 10.1066C10.5303 10.1066 10.2779 9.84396 10.3364 9.53883C10.6782 7.75527 12.1143 7.53845 12.62 7.53845C13.9585 7.53845 14.7311 8.73545 14.7311 9.82363C14.7311 11.7816 13.2337 11.5465 13.0601 13.1199C13.0246 13.4412 12.7792 13.7193 12.4561 13.7193ZM12.4785 14.7096C12.8331 14.7096 13.1206 14.997 13.1206 15.3516V15.4169C13.1206 15.7715 12.8331 16.0589 12.4785 16.0589C12.124 16.0589 11.8365 15.7715 11.8365 15.4169V15.3516C11.8365 14.997 12.124 14.7096 12.4785 14.7096Z"
                fill="#A5AAAF" stroke="#A5AAAF" strokeWidth="0.278846"/>
        </svg>
    );
}

export default InfoIcon;
